/* Only allow mocks in local environment. */
const enableMock =
  process.env.NODE_ENV === `development` || process.env.NEXT_PUBLIC_IS_LOCAL_ENV

/* Mock service change APIs */
export const MOCK_SERVICE_CHANGE_INFORMATION = enableMock && false

/* Mock extra pickup APIs */
export const MOCK_EXTRA_PICKUP_INFORMATION = enableMock && false

/* Mock bulk pickup APIs */
export const MOCK_BULK_PICKUP_INFORMATION = enableMock && false

/* Mock missed pickup APIs */
export const MOCK_MISSED_PICKUP_INFORMATION = enableMock && false

/* Mock Container Repair API */
export const MOCK_CONTAINER_REPAIR_REQUEST = enableMock && false

/* Mock BrightEdge Issue Error Modal Servlet */
export const MOCK_BRIGHTEDGE_ERROR_SERVLET = enableMock && false

/* Mock Container Issue Error Modal Servlet */
export const MOCK_CONTAINER_ERROR_SERVLET = enableMock && false

/* Mock Next.JS API routes */
export const MOCK_GET_NEXT_JS_ENABLED_ROUTES = enableMock && false
